import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFrequencyType } from "../CareElementFrequencyType";
import { BaseCareElement } from "./BaseCareElement";
import { CareElementType } from "./CareElementType";
import { ReportingPeriod } from "./ReportingPeriod";
import { RiskFactorStatus } from "./RiskFactorStatus";

class RiskFactorCareElement extends BaseCareElement {
    public readonly CareElementType: CareElementType.RiskFactor;

    public Status: RiskFactorStatus = RiskFactorStatus.Unknown;

    public ReportingPeriod: ReportingPeriod | null = null;

    public RiskFactorCodeId: string | null = null;

    public Frequency: CareElementFrequencyType = CareElementFrequencyType.None;

    public Details: string | null = null;

    public constructor(init?: NonFunctionProperties<Partial<RiskFactorCareElement>>) {
        super();
        this.Name = init?.Name ?? "";
        this.CareElementType = CareElementType.RiskFactor;
        this.Status = init?.Status ?? RiskFactorStatus.Unknown;
        this.RiskFactorCodeId = init?.RiskFactorCodeId ?? null;
        this.Frequency = init?.Frequency ?? CareElementFrequencyType.None;
        this.ReportingPeriod = init?.ReportingPeriod
            ? new ReportingPeriod(init?.ReportingPeriod)
            : null;
        this.Details = init?.Details ?? null;
    }
}

export { RiskFactorCareElement };
